module.exports = __webpack_public_path__ + "static/images/hhswlb.345cec5bf.png";